/**
 * Storage operations for popup custom module
 * @module popup-custom/storage
 */

/**
 * Checks if a localStorage key exists
 * @param {string} key - The localStorage key to check
 * @param {boolean} defaultOnError - Value to return if localStorage throws
 * @returns {boolean} Whether the key exists
 */
function hasKey(key: string, defaultOnError: boolean): boolean {
  try {
    return !!localStorage.getItem(key);
  } catch {
    return defaultOnError;
  }
}

/**
 * Checks if the popup has already been seen
 * @param {string} storageKey - The localStorage key for this popup instance
 * @returns {boolean} Whether the popup has been seen
 */
export function hasSeen(storageKey: string): boolean {
  return hasKey(storageKey, true);
}

/**
 * Marks the popup as seen in localStorage
 * @param {string} storageKey - The localStorage key for this popup instance
 */
export function markSeen(storageKey: string): void {
  try {
    localStorage.setItem(storageKey, 'true');
  } catch {}
}

/**
 * Checks if a country has already been selected in the location redirect popup
 * @param {string} locationKey - The localStorage key for location redirect choice
 * @returns {boolean} Whether a country has been selected
 */
export function hasCountrySelected(locationKey: string): boolean {
  try {
    const raw = localStorage.getItem(locationKey);
    if (!raw) return false;
    const data: unknown = JSON.parse(raw);
    return !!(data as { country?: unknown } | null)?.country;
  } catch {
    return false;
  }
}
